module.exports = "http://cdn.realive.com.ua/src/views/player/reports/images/ra-logo.png";